<template>
  <div class="modal" v-bind:class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 85% !important; height: 95% !important;">
      <header class="modal-card-head">
        <h1 class="is-size-2 has-text-centered"><strong>Crear Relación</strong></h1>
        <div class="modal-card-title"></div>
        <div class="buttons has-addons is-right">
          <button class="delete is-right" @click="closeModal"></button>
        </div>
      </header>
      <section class="modal-card-body">
        <div class="control has-icons-left has-icons-right">
          <input class="input is-medium" type="text" v-model="search" v-on:keyup.enter="find"
                 placeholder="Buscar"/>
          <span class="icon is-medium is-left">
            <i class="material-icons">search</i>
          </span>
          <span class="icon is-medium is-right">
            <i class="fas fa-check fa-lg"></i>
          </span>
        </div>
        <br>
        <div class="columns">
          <div class="column is-8">
            <div class="container">
              <div style="overflow-y: auto">
                <table v-if='employees.length' class="table is-fullwidth is-fullheight">
                  <thead>
                  <tr>
                    <th>{{ employees.length }}</th>
                    <th>Empleado</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, v) in employees" :key="v">
                    <td>{{ v + (pagination.inicial * 20) + 1 }}</td>
                    <td>
                      <h5 class="title is-5">{{ item.nombre }}</h5>
                      <h6 class="subtitle is-6">{{ item.cargo }}</h6>
                    </td>
                    <td>
                      <div class="buttons is-flex">
                        <a @click="evalutedEmployeeSelected(item)"
                           :class="evaluated._id === item._id? 'is-light' : 'is-link'"
                           class="button">Evaluado</a>
                        <a @click="evaluatorEmployeeSelected(item)"
                           :class="evaluator.length > 0 ? evaluator.find(e => e._id === item._id)? 'is-light' : 'is-link' : 'is-link'"
                           class="button">Evaluador</a>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <td colspan="3">
                      <nav class="pagination" role="navigation" aria-label="pagination">
                        <a class="pagination-previous" @click="previous">Anterior</a>
                        <a class="pagination-previous">{{ pagination.inicial + 1 }}</a>
                        <a class="pagination-next" @click="next">Siguiente</a>
                        <ul class="pagination-list">
                          <li>
                            <a
                                class="pagination-link"
                                :class="pagination.inicial === 0 ? 'is-current' : ''"
                                aria-label="Page 1"
                                aria-current="page"
                                @click="ir(0)"
                            >1</a>
                          </li>
                          <li v-show="pagination.total > 1">
                            <a
                                class="pagination-link"
                                :class="pagination.inicial === 1 ? 'is-current' : ''"
                                aria-label="Goto page 2"
                                @click="ir(1)"
                            >2</a>
                          </li>
                          <li v-show="pagination.total > 2">
                            <a
                                class="pagination-link"
                                :class="pagination.inicial === 2 ? 'is-current' : ''"
                                aria-label="Goto page 3"
                                @click="ir(2)"
                            >3</a>
                          </li>
                          <li>
                            <span class="pagination-ellipsis">&hellip;</span>
                          </li>
                          <li v-show="pagination.total > 5">
                            <a
                                class="pagination-link"
                                :class="pagination.inicial === pagination.mitad -1 ? 'is-current' : ''"
                                @click="ir(pagination.mitad -1)"
                            >{{ pagination.mitad }}</a>
                          </li>
                          <li>
                            <span class="pagination-ellipsis">&hellip;</span>
                          </li>
                          <li v-show="pagination.total > 4">
                            <a
                                class="pagination-link"
                                :class="pagination.inicial === pagination.total-1 ? 'is-current' : ''"
                                aria-label="Goto page 47"
                                @click="ir(pagination.total-1)"
                            >{{ pagination.total }}</a>
                          </li>
                        </ul>
                      </nav>
                    </td>
                  </tr>
                  </tfoot>
                </table>
                <div v-if='!employees.length' class='has-text-centered'>
                  No hay empleados
                </div>
              </div>
            </div>
          </div>
          <div class="column is-4 scroll-light" style="top: 25px; z-index: 41; overflow-y: auto; height: 1389px">
            <div class="has-text-centered">
              <h1><strong>Evaluado</strong></h1>
              <br>
              <p>
                <strong>{{ evaluated.nombre ? evaluated.nombre : 'Nombre' }}</strong>
                <small>{{ evaluated.email ? evaluated.email : 'Correo Electronico' }}</small>
                <br/>
                {{ evaluated.cargo ? evaluated.cargo : 'Cargo' }}
              </p>
            </div>
            <br><br>
            <div class="has-text-centered">
              <h1><strong>Evaluadores</strong></h1>
              <br>
              <div v-for="(e,i) in evaluator" :key="i">
                <p>
                  <strong>{{ e.nombre ? e.nombre : 'Nombre' }}</strong>
                  <small>{{ e.email ? e.email : 'Correo Electronico' }}</small>
                  <br/>
                  {{ e.cargo ? e.cargo : 'Cargo' }}
                </p>
                <br>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="columns">
            <div class="column is-6 is-flex">
              <span data-tooltip="Cerrar" class="tooltip">
              <button
                  class="button"
                  style="margin-right: 10px"
                  @click="closeModal"
              >
                Cancelar
            </button>
          </span>
              <span data-tooltip="Crear Relación" class="tooltip">
              <button
                  class="button is-dark"
                  style="margin-right: 10px"
                  @click="crear"
              >
                Crear
              </button>
            </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import apiServices from "@/services/yungol-services";

export default {
  data() {
    return {
      search: "",
      employees: [],
      pagination: {
        count: 0,
        inicial: 0,
        total: 0,
        mitad: 0,
      },
      evaluados: [],
      evaluadores: [],
      evaluator: [],
      evaluated: {},
    };
  },
  props: {
    show: Boolean,
    proceso: Object,
  },
  methods: {
    evalutedEmployeeSelected(employee) {
      this.$emit("evaluatedEmployee", employee);
      this.evaluated = employee
    },
    evaluatorEmployeeSelected(employee) {
      const ele = this.evaluator.findIndex(e => e._id === employee._id)
      if (ele > -1) {
        this.evaluator.splice(ele, 1)
      } else {
        this.evaluator.push(employee)
      }
    },
    closeModal() {
      this.$emit("showModalEmployee");
    },
    next() {
      if (this.pagination.inicial + 1 < this.pagination.total) {
        this.pagination.inicial++;
        this.find();
      }
    },
    previous() {
      if (this.pagination.inicial > 0) {
        this.pagination.inicial--;
        this.find();
      }
    },
    ir(n) {
      this.pagination.inicial = n;
      this.find();
    },
    async find() {
      const _this = this;
      const f = {
        search: _this.search,
        inicial: _this.pagination.inicial * 20,
      };
      let result;

      try {
        result = await apiServices.post(`/searchemployee/${this.proceso._id}`, f);

        _this.employees = result.data.data;
        _this.pagination.count = result.data.count;
        _this.pagination.total = Math.ceil(_this.pagination.count / 20);
        _this.pagination.mitad = Math.round(
            (_this.pagination.total - 3) / 2 + 3
        );
        /*        console.log("empleados search: ", _this.employees); */
        if (_this.employees.length === 0) {
          _this.pagination.inicial = 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async crear() {
      this.$emit("evaluatorEmployee", this.evaluator);
      await this.$emit("createRelation")
      this.evaluator = []
      this.evaluated = {}
      this.closeModal()
    },
  },
  watch: {
    search(nv, ov) {
      this.find();
    }
  },
  created() {
    this.find();
  },
};
</script>
<style lang="scss">
.m-auto {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalCreateRelacion.vue